/*
 * @Description: Description
 * @Author: Kun Yang
 * @Date: 2022-01-13 09:36:51
 * @LastEditors: Kun Yang
 * @LastEditTime: 2022-01-25 10:17:36
 */
import { Vector3 } from '@babylonjs/core';
import MeshManage from '../meshManage';
import { BASICLENGTHTYPE_ENUM, BASICRENDER_TYPE, BASICTYPE_ENUM } from '../utils/enum';
import { FRAMEDEPTH, TOPFRAME_GROUND } from '../utils/kitchenConfig';
import LengthP2X from '../lengthTypes/lengthP2X';
import LengthX from '../lengthTypes/lengthX';
class renderNoFrame {
    /**
     *
     * @param templateJson
     * @description 检测加高柜后，顶柜/底柜无柜体只有补板侧板情况 ，将补板侧板置为null
     * @returns 处理后的templateJson
     */
    static checkNoFrames(templateJson) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const newTemplateJson = JSON.parse(JSON.stringify(templateJson));
        const bootomType = ((_a = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _a === void 0 ? void 0 : _a.type) === BASICRENDER_TYPE.H;
        // const topType = templateJson?.top?.type;
        if (bootomType) {
            const topFrameLengthX = (_d = (_c = (_b = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _b === void 0 ? void 0 : _b.length1) === null || _c === void 0 ? void 0 : _c.frames) === null || _d === void 0 ? void 0 : _d.length;
            const topFrameLengthP2X = (_g = (_f = (_e = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _e === void 0 ? void 0 : _e.length3) === null || _f === void 0 ? void 0 : _f.frames) === null || _g === void 0 ? void 0 : _g.length;
            const bootomFrameLengthX = (_k = (_j = (_h = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _h === void 0 ? void 0 : _h.length1) === null || _j === void 0 ? void 0 : _j.frames) === null || _k === void 0 ? void 0 : _k.length;
            const bootomFrameLengthP2X = (_o = (_m = (_l = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _l === void 0 ? void 0 : _l.length3) === null || _m === void 0 ? void 0 : _m.frames) === null || _o === void 0 ? void 0 : _o.length;
            if (templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) { // 有顶柜
                // 1.二字型lengthx无顶柜 2.无顶柜加在lengthP2x
                if (topFrameLengthX === 0 || (bootomFrameLengthP2X && !topFrameLengthX)) {
                    if ((_p = newTemplateJson.top) === null || _p === void 0 ? void 0 : _p.length1) {
                        newTemplateJson.top.length1.sidePlates = null; // 处理侧板
                        newTemplateJson.top.length1.sealPlate = null; // 处理补板
                    }
                    // 补板数据只有一个柜体才会置空
                    if (LengthX.checkTopNoFrames(newTemplateJson, BASICTYPE_ENUM.bottom)) {
                        newTemplateJson.bottom.length1.sealPlate = null; // 处理补板
                        newTemplateJson.bottom.length1.length -= newTemplateJson.bottom.length1.rlength; // 处理表现
                    }
                    if (LengthX.checkTopNoFrames(newTemplateJson, BASICTYPE_ENUM.bottom) && ((_q = newTemplateJson.top) === null || _q === void 0 ? void 0 : _q.length1)) {
                        newTemplateJson.top.length1.length -= newTemplateJson.top.length1.rlength; // 处理表现
                    }
                    // 1.二字型lengthP2x无顶柜 2.一字型高柜加在lengthP2x
                }
                else if (topFrameLengthP2X === 0 || (bootomFrameLengthX && !topFrameLengthP2X)) {
                    if ((_r = newTemplateJson.top) === null || _r === void 0 ? void 0 : _r.length3) {
                        newTemplateJson.top.length3.sidePlates = null;
                        newTemplateJson.top.length3.sealPlate = null;
                    }
                    // 补板数据只有一个柜体才会置空
                    if (LengthP2X.checkTopNoFrames(newTemplateJson, BASICTYPE_ENUM.bottom)) {
                        newTemplateJson.bottom.length3.sealPlate = null;
                        newTemplateJson.bottom.length3.length -= newTemplateJson.bottom.length3.rlength;
                    }
                }
                else if (bootomFrameLengthX === 0) { // 1.二字型lengthPx无底柜
                    newTemplateJson.bottom.length1.sidePlates = null;
                    newTemplateJson.bottom.length1.sealPlate = null;
                    newTemplateJson.top.length1.sealPlate = null;
                    newTemplateJson.top.length1.length -= newTemplateJson.top.length1.rlength;
                }
                else if (bootomFrameLengthP2X === 0) { // 1.二字型lengthP2x无底柜
                    newTemplateJson.bottom.length3.sidePlates = null;
                    newTemplateJson.bottom.length3.sealPlate = null;
                    newTemplateJson.top.length3.sealPlate = null;
                    newTemplateJson.top.length3.length -= newTemplateJson.top.length3.rlength;
                }
            }
            else { // 无顶柜
                // eslint-disable-next-line no-lonely-if
                if (LengthX.checkTopNoFrames(newTemplateJson, BASICTYPE_ENUM.bottom)) { // 高柜在LengthX
                    newTemplateJson.bottom.length1.sealPlate = null; // 处理补板
                    newTemplateJson.bottom.length1.length -= newTemplateJson.bottom.length1.rlength; // 处理表现
                }
                else if (LengthP2X.checkTopNoFrames(newTemplateJson, BASICTYPE_ENUM.bottom)) { // 高柜在Length2X
                    newTemplateJson.bottom.length3.sealPlate = null;
                    newTemplateJson.bottom.length3.length -= newTemplateJson.bottom.length3.rlength;
                }
            }
            return newTemplateJson;
        }
        return newTemplateJson;
    }
    static renderSealPlate(sealPlateData, type, lengthType, _this) {
        let sealPlateMesh = null;
        let scaleX;
        let scaleY;
        switch (lengthType) {
            case BASICLENGTHTYPE_ENUM.length1:
                _this.topLength1.initSealPlate(sealPlateData, _this);
                // eslint-disable-next-line consistent-return
                sealPlateData.forEach((plate, plateInx) => {
                    var _a, _b, _c, _d, _e;
                    sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                    // eslint-disable-next-line no-param-reassign
                    _this.sealPlateData = sealPlateData; // 记录补板数据
                    switch (plateInx) {
                        case 0:
                            scaleX = (plate.width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = (FRAMEDEPTH.BOTTOM) / sealPlateMesh.getModelSize().y;
                            (_a = _this.topLength1.sealPlate) === null || _a === void 0 ? void 0 : _a.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            _this.topLength1.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            sealPlateMesh.setModelPosition({
                                x: -sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson),
                                z: -sealPlateMesh.getModelSize().z,
                            });
                            break;
                        case 1:
                            scaleX = (plate.width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = (((_b = _this === null || _this === void 0 ? void 0 : _this.templateJson[type]) === null || _b === void 0 ? void 0 : _b.height) / 100) / sealPlateMesh.getModelSize().y;
                            (_c = _this.topLength1.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            // _this.topLength1.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            sealPlateMesh.setModelPosition({
                                x: -sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson) - sealPlateMesh.getModelSize().y,
                                z: FRAMEDEPTH.BOTTOM,
                            });
                            return sealPlateMesh;
                            break;
                        case 2:
                            scaleX = (plate.width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = (FRAMEDEPTH.BOTTOM) / sealPlateMesh.getModelSize().y;
                            (_d = _this.topLength1.sealPlate) === null || _d === void 0 ? void 0 : _d.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            _this.topLength1.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            sealPlateMesh.setModelPosition({
                                x: -sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson)
                                    - (((_e = _this === null || _this === void 0 ? void 0 : _this.templateJson[type]) === null || _e === void 0 ? void 0 : _e.height) / 100),
                                z: -sealPlateMesh.getModelSize().z,
                            });
                            return sealPlateMesh;
                            break;
                        default:
                            break;
                    }
                });
                break;
            case BASICLENGTHTYPE_ENUM.length3:
                _this.topLength3.initSealPlate(sealPlateData, _this);
                // eslint-disable-next-line consistent-return
                sealPlateData.forEach((plate, plateInx) => {
                    var _a, _b, _c, _d, _e;
                    sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                    // eslint-disable-next-line no-param-reassign
                    _this.sealPlateData = sealPlateData; // 记录补板数据
                    switch (plateInx) {
                        case 0:
                            scaleX = (plate.width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = (FRAMEDEPTH.BOTTOM) / sealPlateMesh.getModelSize().y;
                            (_a = _this.topLength3.sealPlate) === null || _a === void 0 ? void 0 : _a.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            _this.topLength3.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            sealPlateMesh.setModelPosition({
                                x: -sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson),
                                z: FRAMEDEPTH.BOTTOM * 3 - sealPlateMesh.getModelSize().z,
                            });
                            break;
                        case 1:
                            scaleX = (plate.width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = (((_b = _this === null || _this === void 0 ? void 0 : _this.templateJson[type]) === null || _b === void 0 ? void 0 : _b.height) / 100) / sealPlateMesh.getModelSize().y;
                            (_c = _this.topLength3.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            // _this.topLength1.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            sealPlateMesh.setModelPosition({
                                x: -sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson) - sealPlateMesh.getModelSize().y,
                                z: FRAMEDEPTH.BOTTOM * 3 - sealPlateMesh.getModelSize().z,
                            });
                            return sealPlateMesh;
                            break;
                        case 2:
                            scaleX = (plate.width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = (FRAMEDEPTH.BOTTOM) / sealPlateMesh.getModelSize().y;
                            (_d = _this.topLength3.sealPlate) === null || _d === void 0 ? void 0 : _d.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            _this.topLength3.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            sealPlateMesh.setModelPosition({
                                x: -sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson)
                                    - (((_e = _this === null || _this === void 0 ? void 0 : _this.templateJson[type]) === null || _e === void 0 ? void 0 : _e.height) / 100),
                                z: FRAMEDEPTH.BOTTOM * 3 - sealPlateMesh.getModelSize().z,
                            });
                            return sealPlateMesh;
                            break;
                        default:
                            break;
                    }
                });
                break;
            default:
                break;
        }
        return sealPlateMesh;
    }
}
export default renderNoFrame;
